import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

Sentry.init({
  dsn: 'https://f0823c51d8d902c4b19637f33776d398@o4511517646848000.ingest.de.sentry.io/4511553084784720',
  environment: import.meta.env.MODE, // 'production' on Vercel, 'development' locally
  // Send 10 % of sessions for performance tracing in production; 100 % in dev.
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // Only report errors from your own bundle, not from browser extensions etc.
  allowUrls: [/petrotrack\.app/, /vercel\.app/, /localhost/],
  // Don't send errors in local dev unless you explicitly want to test Sentry.
  enabled: import.meta.env.PROD,
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
